import { Icon, IconProps } from '@elkaso-app/web-design';

export const TicketIcon = (props: IconProps) => {
  return (
    <Icon width='24px' height='24px' viewBox='0 0 24 24' fill='gray.500' {...props}>
      <path d='M3.5 17.5H21.5V19.5H3.5V17.5ZM3.5 10.5H21.5V15.5H3.5V10.5ZM3.5 6.5H21.5V8.5H3.5V6.5Z' fill='inherit' />
    </Icon>
  );
};
